import * as actions from './actions';
import * as t from './tracking';

export default function({ getState }) {
  return next => action => {
    switch (action.type) {
      case actions.CALCULATE_SAVINGS:
        next(action);
        const state = getState();
        t.calculatedSavings(
          action.calculatorFormData,
          state.calculator.annualAmountSavings,
          action.calculatorFormData.isPageLoad
        );
        break;
    }
    return next(action);
  };
}



// WEBPACK FOOTER //
// ./app/javascript/apps/calculator/tracking-middleware.js